import React, { useState, useEffect, useMemo } from 'react'

import makeStyles from '@material-ui/core/styles/makeStyles'
import { Typography } from '@material-ui/core'

import { ChapterContent } from '@guidde-co/shared.chapters.chapter-content'

const useStyles = makeStyles({
    timeLine: {
        padding: '0 14px 0 5px'
    }
})
export type BasicChaptersProps = {
    /**
     * array of chapters: {title, applications, start, end, tags, thumbnail}
     */
    chapters: Array<{
        title: string
        end: number
        start: number
        thumbnail: string
    }>
    /**
     * video tag
     */
    videoElement: HTMLVideoElement
    /**
     * User searched string
     */
    searchString?: string
    /*
     * User search results
     */
    onChange?: (searchString: string, counter: number) => void
}

const MIN_SEARCH_LENGTH = 2

export const BasicChapters = ({
    chapters,
    videoElement,
    searchString = '',
    onChange = () => {}
}: BasicChaptersProps) => {
    const classes = useStyles()

    const [activeChapter, setActiveChapter] = useState<number>(0)
    const [currentTime, setCurrentTime] = useState<number>(0)

    const filteredChapters = useMemo(() => {
        // For empty search string or search length under MIN_SEARCH_LENGTH return all the subtitles
        if (searchString.length <= MIN_SEARCH_LENGTH) return chapters

        // limit search results to 50 items
        const res = chapters
            .filter(item =>
                item.title.toLowerCase().includes(searchString.toLowerCase())
            )
            .slice(0, 50)
        onChange(searchString, res.length)
        return res
    }, [searchString, chapters])

    useEffect(() => {
        const index = chapters?.findIndex(chapter => chapter.end > currentTime)
        setActiveChapter(index)
    }, [chapters, currentTime])

    useEffect(() => {
        videoElement?.addEventListener('timeupdate', e => {
            setCurrentTime((e.target as HTMLVideoElement).currentTime)
        })

        return () => {
            videoElement?.removeEventListener('timeupdate', e => {
                setCurrentTime((e.target as HTMLVideoElement).currentTime)
            })
        }
    }, [videoElement])

    return (
        <>
            {filteredChapters?.length === 0 && chapters?.length > 0 && (
                <Typography>
                    We could not find a match for "{searchString}"
                </Typography>
            )}
            <div className={classes.timeLine}>
                {filteredChapters?.map((chapter, idx) => (
                    <ChapterContent
                        key={idx}
                        chapter={chapter}
                        searchString={searchString || ''}
                        isActive={idx === activeChapter}
                        onClick={() => {
                            if (
                                videoElement?.currentTime ||
                                videoElement?.currentTime === 0
                            ) {
                                videoElement.currentTime = chapter.start
                            }
                        }}
                        data-cy="chapter-content"
                    />
                ))}
            </div>
        </>
    )
}
